/* eslint-disable react-hooks/rules-of-hooks */
import { useCallback } from "react";
import { ResourceTypeLink } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { useResourceType } from "../../../../hooks/useResourceType";
import { BulkCopyJob } from "../../CopyResource/types";
import { useBulkCopyLayersJob } from "./useBulkCopyLayersJob";
import { useBulkCopyProjectsJob } from "./useBulkCopyProjectsJob";

interface GetDialogSettingsProps {
  copyLayers?: boolean;
  copyTables?: boolean;
}

export const useGetDialogSettings = (props: GetDialogSettingsProps): [string, () => BulkCopyJob] => {
  const { t } = useTranslation("dialogs");
  const { copyLayers, copyTables } = props;
  const [resourceType] = useResourceType();

  switch (resourceType) {
    case ResourceTypeLink.Project:
      return [
        t("bulkCopy.maps"),
        useCallback(() => useBulkCopyProjectsJob(copyLayers, copyTables), [copyLayers, copyTables]),
      ];
    case ResourceTypeLink.Layer:
      return [t("bulkCopy.layers"), useCallback(() => useBulkCopyLayersJob(copyTables), [copyTables])];
    default:
      return ["", () => ({})];
  }
};
